import React from 'react';
import { styled } from '@material-ui/core/styles';

import DocCard from '../../components/Card/DocCard';
import { DOCS } from '../../constants/docs';
import DevelopersPage from '../../styles/templates/DeveloperPage';
import PageHeader from '../../styles/templates/PageHeader';

interface DocsPageProps {
  path?: string;
  default?: boolean;
}

const StyledList = styled('div')(({ theme }) => ({
  display: 'grid',
  gridGap: '32px',
  gridTemplateColumns: '280px 280px',
  marginTop: '40px',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '298px 298px 298px',
  },
}));

const DocsPage: React.FC<DocsPageProps> = () => (
  <DevelopersPage>
    <PageHeader title="My Documents" subtitle="Search and view helpful documents" />

    <StyledList>
      {DOCS.map((doc) => (
        <DocCard key={doc.link} doc={doc} />
      ))}
    </StyledList>
  </DevelopersPage>
);

export default DocsPage;
